/**
 *
 * AdminSkudFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';

import { ADMIN_SKUD_REQUESTS_FORM, ADMIN_SKUD_REQUESTS_FORM_DIALOG } from './constants';

function AdminSkudFormDialog({ form }) {
  return (
    <AdvancedFormDialog
      name={ADMIN_SKUD_REQUESTS_FORM_DIALOG}
      formName={ADMIN_SKUD_REQUESTS_FORM}
      advancedForm={form}
      addModeTitle="Новая заявка"
      editModeTitle="Изменение заявки"
      viewModeTitle="Просмотр заявки"
      copyModeTitle="Копирование заявки"
    />
  );
}

AdminSkudFormDialog.propTypes = {
  form: PropTypes.node.isRequired,
};

export default AdminSkudFormDialog;
